import { useFormContext, useWatch } from 'react-hook-form';
import { useBootstrapState } from '../../../../../bootstrap/bootstrap-provider';
import { TabBody } from '../../../../../panels/entity-panels/tabs/tab-body';
import { TabSubtitle } from '../../../../../panels/entity-panels/tabs/tab-subtitle';
import { FormBody } from '../../../../../forms/integrated-form-components/form-body';
import { BoloPanelFormType } from '@mark43/cad-api';
import { BoloPanelTab } from '../bolo-panel-tab';
import { BoloPanelFormPersonsFields } from '../../../form/bolo-panel-form-persons-fields';

export const BoloPanelPersonsTab = () => {
    const boloPanelForm = useFormContext<BoloPanelFormType>();

    const involvedPersons = useWatch({
        control: boloPanelForm.control,
        name: 'involvedPersons',
    });

    const eventPanelOptions = useBootstrapState().eventPanelOptions;

    return (
        <BoloPanelTab title="Persons">
            <TabBody>
                <TabSubtitle>Involved Persons ({involvedPersons.length})</TabSubtitle>
                <FormBody>
                    <BoloPanelFormPersonsFields
                        form={boloPanelForm}
                        displayAsCards={true}
                        noMembersText="No Involved Persons"
                        allowMembersControl={true}
                        eventPanelOptions={eventPanelOptions!}
                    />
                </FormBody>
            </TabBody>
        </BoloPanelTab>
    );
};
